
var faq = {
	selectors: {
        viewLink: '[view-faq-inline]',
        parent: '.faq-inline',
	},
	init: function () {
		var self = this;

        jQuery(self.selectors.viewLink).on('click', function (event) {
            event.preventDefault();
            jQuery(this).closest(self.selectors.parent).addClass('view-all'); 
        });
	},
};

export { faq };
